"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, _toPropertyKey(descriptor.key), descriptor); } }
function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); Object.defineProperty(Constructor, "prototype", { writable: false }); return Constructor; }
function _toPropertyKey(arg) { var key = _toPrimitive(arg, "string"); return _typeof(key) === "symbol" ? key : String(key); }
function _toPrimitive(input, hint) { if (_typeof(input) !== "object" || input === null) return input; var prim = input[Symbol.toPrimitive]; if (prim !== undefined) { var res = prim.call(input, hint || "default"); if (_typeof(res) !== "object") return res; throw new TypeError("@@toPrimitive must return a primitive value."); } return (hint === "string" ? String : Number)(input); }
var tv4 = require('tv4');
var _require = require('../../constant/relationship/label.constant'),
  EDGE = _require.EDGE;
var Role = /*#__PURE__*/function () {
  function Role() {
    var opt = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
    _classCallCheck(this, Role);
    this.id = null;
    this.name = null;
    this.active = null;
    this.fillObject(opt);
  }
  _createClass(Role, [{
    key: "fillObject",
    value: function fillObject(opt) {
      this.id = opt.id || null;
      this.name = opt.name || null;
      this.active = opt.active || true;
    }
  }, {
    key: "validate",
    value: function validate() {
      return tv4.validateMultiple(this, Role.schema());
    }
  }], [{
    key: "schema",
    value: function schema() {
      return {
        $schema: 'http://json-schema.org/draft-04/schema#',
        id: 'role.schema.json',
        type: 'object',
        additionalProperties: false,
        properties: {
          id: {
            type: 'number'
          },
          name: {
            "enum": Object.keys(EDGE)
          },
          active: {
            type: 'boolean'
          }
        },
        required: Object.keys(new Role())
      };
    }
  }]);
  return Role;
}();
tv4.addSchema(Role.schema());
module.exports = Role;